import React,{useState, useEffect} from "react";

import clsx from "clsx";
import InfoBlock from "./InfoBlock";
import SensorWrap from "./SensorWrap";
import SensorsType500 from "./SensorsType500";

import {FilterStatus, WsGroup, WsGroups} from "../../../store/branches/sensors/stateTypes";

import classes from "../SensorDashboard.module.scss";
import HeatMap from "./HeatMap";

interface Sensors {
    group: WsGroup
    wsDataId: string
    groupId: string
    sensorsGroupsName?: string
    groupNumber: number
    deviceType: string
    groupName?: string
    filter_status?: FilterStatus,
}

const SensorsGroups: React.FC<Sensors> = ({
                                              group,
                                              wsDataId,
                                              groupId,
                                              sensorsGroupsName,
                                              groupNumber,
                                              deviceType,
                                              groupName,
                                              filter_status,
                                          }) => {

    const isF500Type = deviceType === "f500"
    const isEth3 = deviceType === "0007"
    const [selectedSensors, setSelectedSensors] = useState([]);

  useEffect(() => {
  if (!isEth3 || !Array.isArray(group?.sensors) || !Array.isArray(selectedSensors)) return;

  const updatedSelectedSensors = group.sensors.filter(
    (sensor) =>
      sensor?.Status === "WARNING" || selectedSensors.some((s) => s?.Id === sensor?.Id)
  );

  if (JSON.stringify(updatedSelectedSensors) !== JSON.stringify(selectedSensors)) {
    setSelectedSensors(updatedSelectedSensors);
  }
}, [group?.sensors, isEth3, selectedSensors, setSelectedSensors]);


  const handleSensorClick = (sensorId) => {
  setSelectedSensors((prevSelected) => {
    const isSelected = prevSelected.some((sensor) => sensor.Id === sensorId);

    if (isSelected) {
      // If the sensor is already selected, remove it
      return prevSelected.filter((sensor) => sensor.Id !== sensorId);
    } else {
      // If the sensor is not selected, add it
      const sensorToAdd = group.sensors.find((sensor) => sensor.Id === sensorId);
      return [...prevSelected, sensorToAdd];
    }
  });
};


    return (
        <div className={clsx(deviceType === "f500"
            ? classes.deviceType500Block
            : group.Name === "Alignment" ? classes.alignment : "")}>

            {
                isEth3 ?
                    <React.Fragment>
                        <InfoBlock
                            group={group}
                            status={group?.Status}
                            isSensors={!!group?.sensors}
                            isAlarmedGroup={group.Alarm}
                            sensorsGroupsName={sensorsGroupsName}
                        />

                        <HeatMap sensors={group?.sensors} onSensorClick={handleSensorClick} selectedSensors={selectedSensors}/>

                             <div className={classes.mapBlock}>
                            {selectedSensors.map((item, index) => (
                                <SensorWrap sensor={item}
                                            wsDataId={wsDataId}
                                            groupId={groupId}
                                            sensorsId={item.Id}
                                            groupsId={item.Id}
                                            key={`${item.Id}${index}1-1`}
                                            sensorNumber={index + 1}
                                            filter_status={filter_status}
                                            groupNumber={groupNumber}/>
                            ))}
                        </div>

                    </React.Fragment>
                    :
                    isF500Type
                        ?
                        <React.Fragment>
                            {
                                <div className={classes.sensorsGroupBlockWrap}>
                                    <div className={classes.sensorsGroupBlockTitle}>
                                        <span>{groupName}</span>
                                    </div>
                            </div>
                        }
                        <div>
                            {group?.groups?.map((item: WsGroups, index: number) => {
                                if (filter_status === FilterStatus.ACTIVE) {
                                    if (!item.sensors) {
                                        return null;
                                    }
                                    return <SensorsType500 groupNumber={groupNumber}
                                                           filter_status={filter_status}
                                                           wsDataId={wsDataId}
                                                           groupId={groupId}
                                                           groupsId={item.Id}
                                                           f500GroupID={group.Id}
                                                           wsGroup={item}
                                                           isF500Type={isF500Type}
                                                           isAlarmedGroup={group.Alarm}
                                                           key={`sensor_f500_group${index}`}
                                                           groupName={group.Name}

                                    />;
                                }

                                if (filter_status === FilterStatus.ALARMED) {
                                    if (item.Alarm) {
                                        return <SensorsType500 groupNumber={groupNumber}
                                                               filter_status={filter_status}
                                                               wsDataId={wsDataId}
                                                               groupId={groupId}
                                                               groupsId={item.Id}
                                                               isF500Type={isF500Type}
                                                               f500GroupID={group.Id}
                                                               wsGroup={item}
                                                               isAlarmedGroup={group.Alarm}
                                                               key={`sensor_f500_group${index}`}
                                                               groupName={group.Name}
                                        />;
                                    }
                                    return null;
                                }

                                return <SensorsType500 groupNumber={groupNumber}
                                                       filter_status={filter_status}
                                                       wsDataId={wsDataId}
                                                       groupId={groupId}
                                                       groupsId={item.Id}
                                                       isF500Type={isF500Type}
                                                       f500GroupID={group.Id}
                                                       wsGroup={item}
                                                       isAlarmedGroup={group.Alarm}
                                                       key={`sensor_f500_group${index}`}
                                                       groupName={group.Name}
                                />;
                            })}
                        </div>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <InfoBlock
                            group={group}
                            status={group?.Status}
                            isSensors={!!group?.sensors}
                            isAlarmedGroup={group.Alarm}
                            sensorsGroupsName={sensorsGroupsName}
                        />
                        <div className={classes.mapBlock}>
                            {group?.sensors?.map((item, index) => (
                                <SensorWrap sensor={item}
                                            wsDataId={wsDataId}
                                            groupId={groupId}
                                            sensorsId={item.Id}
                                            groupsId={group.Id}
                                            key={`${item.Id}${index}1-1`}
                                            sensorNumber={index + 1}
                                            filter_status={filter_status}
                                            groupNumber={groupNumber}
                                            groupName={group.Name}
                                />
                            ))}
                        </div>
                    </React.Fragment>

            }

            {
                group.Name === "Alignment" && !!group?.groups?.length
                &&
                <React.Fragment>
                    <InfoBlock
                        group={group}
                        status={group?.Status}
                        isSensors={true}
                        isAlignment={true}
                        sensorsGroupsName={groupName}
                    />

                    <div className={clsx(classes.mapBlock, classes.alignment)}>
                        {group?.groups?.map((item, index) => {

                            return <SensorsType500 groupNumber={groupNumber}
                                                   wsGroup={item}
                                                   key={`alignment_${index}`}
                                                   wsDataId={wsDataId}
                                                   groupId={groupId}
                                                   groupsId={item.Id}
                                                   f500GroupID={group.Id}
                                                   alignmentID={item.Id}
                                                   filter_status={filter_status}
                                                   isAlignment={true}
                                                   groupName={group.Name}
                            />;
                        })}
                    </div>
                </React.Fragment>
            }
        </div>
    );
};

export default SensorsGroups;
